import theme from "@/constants/theme";

export const styles: Record<string, React.CSSProperties> = {
  imageContainer: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "black",
    overflow: "hidden",
    position: "relative",
    objectFit: "contain",
    borderRadius: "8px",
    maxHeight: "100%",
  },
  img: {
    width: "100%",
    height: "100%",
    position: "absolute",
    objectFit: "contain",
  },
  indicator: {
    position: "absolute",
    top: 10,
    right: 10,
    zIndex: 10,
    backgroundColor: "rgba(255, 255, 255, 0.24)",
    padding: 8,
    borderRadius: 8,
    border: "none",
    color: theme.colors.text.default,
  },
};
